import axios from "axios";

const updateAccount = (company_id, account_id, account) => {
  return axios.patch(
    `/api/v1/companies/${company_id}/company_accounts/${account_id}`,
    account
  );
};

const updateDontSuggestAccount = (company_id, account) => {
  return axios.patch(
    `/api/v1/companies/${company_id}/company_accounts/update_dont_suggest_account`,
    account
  );
};

const ApiCompanyAccount = {
  updateAccount,
  updateDontSuggestAccount
};

export default ApiCompanyAccount;
